import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/caminhao/novo")({
  head: () => ({
    meta: [{ name: "title", content: "Cadastrar Caminhão" }]
  })
});
